exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup_inputW_71c8bda{width:440px!important}", ""]);

// exports
exports.locals = {
	"popup_inputW": "popup_inputW_71c8bda"
};